import {
  VALIDATE_USERS,
  RESET_INPUTTED_USERS,
  GET_USERS,
  GET_USER_DETAILS,
  EDIT_USER,
  ONBOARD_USERS,
  LOCK_USER_ACCOUNT,
  UNLOCK_USER_ACCOUNT,
  requestType,
  succeedType,
  failedType,
} from "./../actions/actionTypes";

const initState = {
  new_users: null,
  existing_users: null,
  users: [],
  is_fetching: false,
  edit_loading: false,
  onboarding_users: false,
  locking_user_account: false,
  unlocking_user_account: false,
};

export const userReducer = (state = initState, action) => {
  switch (action.type) {
    case succeedType(VALIDATE_USERS):
      return {
        ...state,
        new_users: [...action.new_users],
        existing_users: [...action.existing_users],
      };
    case RESET_INPUTTED_USERS:
      return {
        ...state,
        new_users: null,
        existing_users: null,
      };
    // case requestType(GET_USER_DETAILS):
    case requestType(GET_USERS):
      return {
        ...state,
        is_fetching: true,
      };
    case failedType(GET_USER_DETAILS):
    case failedType(GET_USERS):
      return {
        ...state,
        is_fetching: false,
      };
    case succeedType(GET_USERS):
      return {
        ...state,
        is_fetching: false,
        users: action.users,
      };
    case succeedType(GET_USER_DETAILS):
      return {
        ...state,
        is_fetching: false,
        users: state.users.map((user) => {
          if (user.id == action.user.id) {
            return { ...user, ...action.user };
          } else {
            return user;
          }
        }),
      };
    case requestType(ONBOARD_USERS):
      return {
        ...state,
        onboarding_users: true,
      };
    case succeedType(ONBOARD_USERS):
      return {
        ...state,
        onboarding_users: false,
      };
    case failedType(ONBOARD_USERS):
      return {
        ...state,
        onboarding_users: false,
      };
    case requestType(LOCK_USER_ACCOUNT):
      return {
        ...state,
        locking_user_account: true,
      };
    case succeedType(LOCK_USER_ACCOUNT):
      return {
        ...state,
        locking_user_account: false,
      };
    case failedType(LOCK_USER_ACCOUNT):
      return {
        ...state,
        locking_user_account: false,
      };
    case requestType(UNLOCK_USER_ACCOUNT):
      return {
        ...state,
        unlocking_user_account: true,
      };
    case succeedType(UNLOCK_USER_ACCOUNT):
      return {
        ...state,
        unlocking_user_account: false,
      };
    case failedType(UNLOCK_USER_ACCOUNT):
      return {
        ...state,
        unlocking_user_account: false,
      };
    case requestType(EDIT_USER):
      return {
        ...state,
        edit_loading: true,
      };
    case failedType(EDIT_USER):
      return {
        ...state,
        edit_loading: false,
      };
    case succeedType(EDIT_USER):
      return {
        ...state,
        edit_loading: false,
      };
    default:
      return state;
  }
};
